import { render, staticRenderFns } from "./ListComissoes.vue?vue&type=template&id=183fe2e8&"
import script from "./ListComissoes.vue?vue&type=script&lang=js&"
export * from "./ListComissoes.vue?vue&type=script&lang=js&"
import style0 from "./ListComissoes.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports